import { MatDialog } from '@angular/material';
import { ConversationService } from './../../../Services/conversationService';
import { AppNavComponent } from './../../../Nav/app-nav.component';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';
import { MainService } from './../../../Services/service.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DeleteAccountDialog } from '../../../Dialogs/delete-account-dialog/delete-account-dialog.component';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AccountComponent extends AppNavComponent {

  public enableSubscription: boolean = false;

  constructor(mainService: MainService, conversationService: ConversationService, dialog: MatDialog) {
    super(mainService, conversationService, dialog);
    this.enableSubscription = mainService.enableSubscription;
    mainService.pageName = "My Account";
  }

  showAllNonDemoAds() {
    this.mainService.route.navigate(["/non-demo-ads"]);
  }

  showDeleteAccountModal() {
    const dialogRef = this.dialog.open(DeleteAccountDialog, {
      autoFocus: true,
      hasBackdrop: true,
      disableClose: true,
      data: {},
    });
  }
}
